import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/logo.png'


const _hoisted_1 = { class: "pt-6 w-full" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "w-full flex justify-center" }, [
  /*#__PURE__*/_createVNode("img", {
    alt: "Vue logo",
    src: _imports_0,
    class: ""
  })
], -1)
const _hoisted_3 = { class: "w-full flex justify-center" }

import { ref } from "vue";
import { default as HelloWorld } from "@/components/HelloWorld.vue";
import { default as ButtonClickAdd } from "@/components/ButtonClickAdd.vue";


export default _defineComponent({
  setup(__props) {

const webName = ref("Vue.js + TypeScript + Tailwind");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(ButtonClickAdd),
    _createVNode(HelloWorld, {
      class: "w-full flex justify-center",
      msg: "Welcome to "
    }),
    _createVNode("div", _hoisted_3, _toDisplayString(webName.value), 1)
  ]))
}
}

})